import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { UserSetup } from '../page/user-setup';
import { ToastContainer } from 'react-toastify';

export function initUserSetup() {
  document.getElementsByName('user-setup').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, tab, ...dataset } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <UserSetup {...dataset} tab={tab} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
